import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import history from '../../history';
import { useisLoading } from '../../hook/useisLoading';
import Loading from '../../components/common/Loading';
import { UsersAPI } from '../../components/apis';
import InputField from '../../components/common/InputField';
import Checkbox from '../../components/common/Checkbox';
import { useForm } from 'react-hook-form';
import PageHeaderStandar from '../../components/common/PageHeaderStandar';
import { ButtonEdit } from '../../components/common/ButtonEdit';
import { ButtonBack } from '../../components/common/ButtonBack';
import { ButtonDelete } from '../../components/common/ButtonDelete';
import ErrorMessage from '../../components/common/ErrorMessage';
import { message } from '../../components/common/Notification';
import types from '../../types/types';
import { helperConfirmationAlert } from '../../components/helpers/helperConfirmationAlert';
import { Redirect } from 'react-router-dom';


export const User = (props, context) => {

    console.log("Enter into UserOLD.js");
    
    const { token } = useSelector(state => state.user);

    // Variable to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);

    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue } = useForm({
        defaultValues: {
            // User default attribute for create new entity
          
            user: null, // for load user from API request
            id: "",
            given_name: "",
            family_name: "",
            email: "",
            user_name: "",
            enabled: true,
            account_id: null,
            password: "",
            confirm_password: "",
            phone_number: "",
            role_id: null,
            role: "",
            account: "",
            created_at: "",
            //   // Axuliar varialbes to los acctounts and roles values from services.
            //   accounts: null,
            //   roles: null,
    
            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            
            goToEdit: null,
            goToUsersList: null,
        }
    });

    const [apiUser, setApiUser] = useState(null);
    const [user, setUser] = useState(null);
    
    // Load API Object
    useEffect(() => {
    
        if (token) {
            setApiUser(new UsersAPI(token));
        }

    }, [token])

    // Use effect to load user table data from API request.
    useEffect( () => {
        if (apiUser){

            apiUser.get(encodeURI(props.id)).then(  (user) => {

                // Setting user in react-hook-form objet named "user"
                setValue("user", user);
                setValue("id", user.id);
                setValue("given_name", user.given_name);
                setValue("family_name", user.family_name);
                setValue("email", user.email);
                setValue("phone_number", user.phone_number);
                setValue("user_name", user.user_name);
                setValue("role", user.roles[0]);
                setValue("account", user.accounts[0]);
                setValue("enabled", user.enabled);
                setValue("account_id", user.accounts[0].id);
                setValue("verified_email", user.verified_email);
                setValue("created_at", user.created_at);

            }).catch(err => {

                console.log("Error getting user from User.js: " + err)
                setValue(types.ERROR,  context.t("There was a problem on our end. Please try again later."));

            }).finally(() => {

                hideSpinner();

            });
        }

    }, [apiUser]);

    // Function to remove User (logical delete)
    const _removeUser = () => {

        // Starting spinner
        showSpinner();
        debugger
        
        const userId = getValues().id;
        const userAccountId=  getValues().account_id;

        apiUser.delete(userId).then(() => {

            setValue("goToUsersList", '/users');
            message(context.t("User deleted"), context.t("User deleted successfully"));
            
        }).catch(err => {

            console.log(err);
            // Set "backendError" show a back-end error as message to the user at the top.
            setValue("backendError",  err.message );

        }).finally(() => {
            // Stop spinnner and render page.
            hideSpinner();

        });
    }

    // Funtion to handle elimination of user. It shows a popup confirmaton to the user.
    const handleRemoveUser = (event) => {
        event.preventDefault();
        event.stopPropagation();

        helperConfirmationAlert(context, null, context.t("Are you sure you want to delete the user?"), context.t("Yes"), context.t("No"), _removeUser, null );
        
    }

    // Redirecting to user list
    if (getValues().goToUsersList){

        return <Redirect to={getValues().goToUsersList} />
    }
   

    // If is loading or not load user data yet, we show the spinner.
    if (isLoading || !getValues().user) {
        return <Loading/>
    } else {
        return  (
                <div>
                    <Container fluid>
                        {/* If "backendError" has value, it shows to the user */}
                        <ErrorMessage message={getValues().backendError}/>

                        {/* Page header has Title and Subtite of the page */}
                        <PageHeaderStandar title={context.t('User')} subtitle={context.t('Visualization')} />
                        <Form action={'/users/edit/'+ getValues().user.id} validate="true">
                            <Card className='snx-card' style={{ padding: "15px"}} >
                                    <Row>
                                    <Col lg="5" className='mb-4'>
                                        <Card>
                                            <Card.Header className="border-bottom text-center">
                                                <div>
                                                    <i className="material-icons snx-icon md-48">account_circle</i>
                                                </div>
                                                <h3>{ getValues().user_name }</h3>
                                                <br/>
                                                <strong className="text-muted d-block mb-1">{context.t('Role')}</strong>
                                                <span><b><h5>{ getValues().role.name }</h5></b></span>
                                                <br/>

                                                <strong className="text-muted d-block mb-1">{context.t('Account')}</strong>
                                                <span><b><h5>{ getValues().account.name }</h5></b></span>

                                            </Card.Header>
                                            <Card.Body className="text-center">
                                                <strong className="text-muted d-block mb-2">{context.t('Edit')}</strong>
                                                <ButtonEdit to={'/users/edit/'+ getValues().user.id} />
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col lg="7">
                                        <Card>
                                            <Card.Header className="border-bottom">
                                                <h6 className="m-0" style={{ float: "left"}}>{context.t('Details')}</h6>
                                                
                                                <ButtonBack onClick={e => { history.goBack() }} />
                                            </Card.Header>
                                            <Card.Body className="pt-0">
                                                <Row className="border-bottom py-2 bg-light">
                                                    <Col sm="12" className="mb-2 mb-sm-0" style={{paddingTop: "7px"}}>
                                                        <b><i className="material-icons">access_time</i> { getValues().created_at }</b>
                                                    </Col>
                                                </Row>
                                                <br/>
                                                <Row>
                                                    <Col>
                                                        <InputField label= { context.t('First Name') }
                                                            name="given_name"
                                                            disabled={true}
                                                            useFormRegister= { register("given_name") }
                                                        />
                                                        <InputField label= { context.t('Last Name') }
                                                            name="family_name"
                                                            disabled={true}
                                                            useFormRegister= { register("family_name") }
                                                        />
                                                        <InputField label= { context.t('Email') }
                                                            name="email"
                                                            disabled={true}
                                                            useFormRegister= { register("email") }
                                                        />
                                                        <InputField label= { context.t('Phone') }
                                                            name="phone_number"
                                                            disabled={true}
                                                            useFormRegister= { register("phone_number") }
                                                        />
                                                        <Checkbox label={context.t('Enabled')} 
                                                            name="enabled" 
                                                            disabled={true} 
                                                            useFormRegister= { register("enabled") }
                                                        />
                                                        <Checkbox label={context.t('Verified Email')} 
                                                            name="verified_email" 
                                                            disabled={true} 
                                                            useFormRegister= { register("verified_email") } 
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="pull-right float-right">
                                                    <ButtonDelete onClick={e => { handleRemoveUser(e) }} />
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card>
                        </Form>
                    </Container>
                    <br/>
                </div>
            )
    }
}

User.contextTypes = {
    t: PropTypes.func.isRequired
}

export default User;
